<template>
  <div
    v-if="basePrices"
    :class="[
      'base-price-fi',
      small ? 'base-price-fi--small' : '',
      theme ? `base-price-fi--theme-${theme}` : '',
    ]"
  >
    <div
      v-for="(basePrice, idx) in basePrices"
      :key="idx"
    >
      <template v-if="basePrice.valueFormatted">
        {{ basePrice.valueFormatted }}
      </template>

      <template v-if="bestPrice.priceRows">
        / {{ basePrice.qty }} {{ getSellingUnit(basePrice.unit)
        }}{{ idx !== basePrices.length - 1 ? ', ' : '' }}
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { getSellingUnit } from 'composables/sellingUnit';
import { computed } from 'vue';

defineOptions({
  name: 'BasePriceFi',
});

interface BasePrice {
  unit: string;
  qty: number;
  valueFormatted?: string;
}

const props = withDefaults(
  defineProps<{
    bestPrice: {
      priceRows?: any;
      price?: {
        basePrices: BasePrice[];
      };
    };
    small?: boolean;
    theme?: string | null;
  }>(),
  {
    bestPrice: () => ({}),
    theme: null,
  },
);

const basePrices = computed<BasePrice[] | undefined>(() => props.bestPrice?.price?.basePrices);
</script>

<style scoped lang="scss">
@import './base-price-fi';
</style>
